import React from 'react';
import { Title, useTranslate } from 'react-admin';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';
import TicketsPanel from '../components/tickets/TicketsPanel';
import EventSessionUrlScopeBar from '../components/events/EventSessionUrlScopeBar';
import { getTicketsPageTitle } from '../utils/ticketsUtils';

const TicketsPage = () => {
  const translate = useTranslate();
  const [searchParams] = useSearchParams();
  const eventID = searchParams.get('eventID');
  const stockID = searchParams.get('stockID');
  const pnr = searchParams.get('pnr');
  const { title } = getTicketsPageTitle(eventID, stockID, translate);

  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <Title title={title} />
      {eventID ? <EventSessionUrlScopeBar eventID={eventID} /> : null}
      <TicketsPanel eventID={eventID} stockID={stockID} pnr={pnr} />
    </Box>
  );
};

export default TicketsPage;
